import axios from 'axios'

/**
 * Instancia centralizada de axios con interceptor para manejar
 * tokens expirados (401/403). Cuando el backend responde con
 * 401 o 403 se limpia la sesión y se redirige al login.
 */
const axiosInstance = axios.create()

// Variable para evitar múltiples redirecciones simultáneas
let isRedirecting = false

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status
    const responseMessage = error?.response?.data?.message || ''
    const isTokenError = status === 401 ||
      (status === 403 && (
        responseMessage.toLowerCase().includes('token') ||
        responseMessage.toLowerCase().includes('expired') ||
        responseMessage.toLowerCase().includes('unauthorized')
      ))

    if (isTokenError && !isRedirecting) {
      isRedirecting = true

      localStorage.removeItem('hashUser'); 
      localStorage.removeItem('hashInfo');

      //localStorage.clear()
      sessionStorage.clear()

      // Redirigir al login
      //window.location.href = '/'

      window.dispatchEvent(new CustomEvent('session-expired'));

      
      // Resetear flag después de un tiempo prudente
      setTimeout(() => {
        isRedirecting = false
      }, 3000)
    }

    return Promise.reject(error)
  }
)

export default axiosInstance
